<template>
  <v-dialog v-model="dialog.show" max-width="800" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="10">
              <v-text-field
                v-model="financiamento.descricao"
                :rules="[rules.required]"
                label="Descricao"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="financiamento.ativo"
                label="Ativo"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="financiamento.entradaMinima"
                :rules="[rules.required, rules.isNumber]"
                label="Entrada Minima"
                suffix="%"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="financiamento.idBanco"
                :rules="[rules.required]"
                label="ID Banco"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!dialog.edit">
              <SelectProdutoForca
                :multiple="true"
                @onChanged="financiamento.produto = $event"
              />
            </v-col>
            <v-col cols="12" v-if="!dialog.edit">
              <SelectEmpresa
                :multiple="true"
                @onChanged="financiamento.empresas = $event"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit ? editItem() : save()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Financiamento from "@/services/financiamentoProdutoForca";

export default {
  name: "DialogFinanciamentoProdutoForca",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectProdutoForca: () => import("@/components/select/SelectProdutoForca")
  },

  data() {
    return {
      dialog: {
        title: "",
        show: false,
        edit: false
      },
      rules,
      financiamento: {
        idBanco: "",
        ativo: true,
        descricao: "",
        empresas: [],
        entradaMinima: 0,
        produto: []
      },
      serviceFinanciamento: new Financiamento()
    };
  },

  methods: {
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.financiamento.idBanco.replaceAll(" ", "");
          this.formatValuesToFloat();
          const newFinanciamento = await this.serviceFinanciamento.create({
            ...this.financiamento
          });
          this.$emit("created", { ...newFinanciamento });
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao cadastrar novo Financiamento");
        return Promise.reject(error);
      }
    },

    async editItem() {
      try {
        if (this.$refs.form.validate()) {
          this.financiamento.idBanco.replaceAll(" ", "");
          const response = await this.serviceFinanciamento.update({
            ...this.financiamento
          });
          this.$emit("updated", { ...this.financiamento });
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao editar Financiamento");
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog.show = false;
    },

    show(edit, item) {
      if (edit) {
        this.financiamento = { ...item };
        this.dialog.title = "Editar Financiamento";
        this.dialog.edit = true;
      } else {
        this.dialog.title = "Novo Financiamento";
      }
      this.dialog.show = true;
    },

    formatValuesToFloat() {
      this.financiamento.entradaMinima = parseFloat(
        this.financiamento.entradaMinima
      );
    }
  }
};
</script>
